import React, { Component } from "react";
import axios from "axios";
import { authService } from "../auth";
import Header from "../Header";
import LeftPanel from "../LeftPanel";
import * as _ from "lodash";
import "./main-forum.min.css";
import AddCommentBox from "../commons/AddCommentBox";
import Comment from "../commons/Comment";
import Share from "../commons/Share";
import Pinned from "../commons/Pinned";
import $ from "jquery";
import Follow from "../commons/Follow";
import BypassHeader from "../BypassHeader";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import SignUpModal from "../SignUpModal/signUpModal";
import UnauthShare from "../commons/UnauthShare";
import { getCDNUrl, userAgentGetData, adminFlagData } from "../commons/CommonFunctions";
import ReportAbuse from "../commons/ReportAbuse";
import { Link, Redirect, withRouter } from "react-router-dom";
import cloneDeep from "lodash/cloneDeep";
import LeftPanelUnauth from "../commons/LeftPanelUnauth";
import HideInfoPage from "../static/HideInfoPage";
import UnauthPageItem from "../UnauthPageItem/UnauthPageItem";
import PrivateProjectHidePage from "../static/PrivateProjectHidePage";
import UserReactionComponent from "../UserReaction/UserReactionComponent";
import OrganizationAdmin from "../commons/OrganizationAdmin";
import { pageClickHookPostMethod } from "../services/PostApi";
import CommonPostViews from "../post/CommonPostViews";
import uuid from "react-uuid";
class ForumDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: authService.getUserDetailsFromLocalStorage(),
      loginSuccess: authService.isAuthenticated(),
      forumData: {},
      error: null,
      userComment: "",
      like: true,
      comments: "",
      commentCount: "",
      forumTreningData: [],
      opportunities: [],
      unAuthPost: [],
      unAuthCircle: [],
      projectDetail: {},
      pageSize: 16,
      pageNo: 0,
      loginRequired: false,
      notFoundstatusCode: false,
      successMessage: "",
      isModalOpen: false,
      projectId: undefined,
      forumResponseMessage: "",
      adminFlag: false,
      userId: authService.isAuthenticated() && (this.props?.location?.state?.userId ? this.props?.location?.state?.userId : authService.getUserDetailsFromLocalStorage().userId),
      analyticsPanelEnabled: false,
      showStatsFlag: false
    };
  }

  componentDidMount() {
    this.getForumDetails();
    if (this.state.loginSuccess) {
      this.setState(
        {
          trendingUrl:
            "/forum/trending?userId=" +
            this.state.userId +
            "&page=" +
            this.state.pageNo +
            "&size=" +
            this.state.pageSize + userAgentGetData(),
        },
        () => {
          //this.getTrendingList();
        }
      );
    } else {
      setTimeout(() => {
        this.setState({ ...this.state });
      }, 1500);
    }
    
    $("#commntIco").on("click", function (event) {
      event.preventDefault();
      $("#commentbox textarea").focus();
    });

   
  }

  handlePageClickHookPost = async () => {
    let postData = {
      entityId: this.state.forumData?.id,
      userId: this.state.loginSuccess ? this.state.userData?.userId : null,
      entityType: "FORUM"
    }
    
    await pageClickHookPostMethod(postData);
}

  getOptimizedImage(personalInfo) {
    if (
      personalInfo.resizedProfileImages &&
      personalInfo.resizedProfileImages["200x200"] != null
    ) {
      return personalInfo.resizedProfileImages["200x200"];
    }
    return personalInfo.profileImage;
  }

  getOptimizedFacultyImage = (personalInfo, defaultImg) => {
    if (
      personalInfo.resizedProfileImages &&
      personalInfo.resizedProfileImages["200x200"] != null
    ) {
      return personalInfo.resizedProfileImages["200x200"];
    }
    return defaultImg;
  };

  getCost = (project) => {
    let fees = "";
    if (
      (project && project.cost) ||
      project.remuneration ||
      project.renumeration
    ) {
      fees = project.cost || project.remuneration || project.renumeration;
    }
    return fees;
  };

  handleUserCommentChange = (e) => {
    this.setState({ userComment: e.target.value });
  };

  handleLike() {
    this.setState({ loginRequired: true });
    window.$("#loginModal").modal("show");
  }

  signUpRequired = () => {
    this.setState({ signUpRequired: true });
    window.$("#signupModal").modal("show");
  };

  handleSignUpClose = () => {
    this.setState({ signUpRequired: false });
    window.$("#signupModal").modal("hide");
  };

  loginRequired = (slug) => {
    this.setState({ loginRequired: true, pathname: slug });
    window.$("#loginModal").modal("show");
  };

  componentWillUnmount() {
    window
      .$("#confirmpopForDeleteForum" + this.state.forumData.id)
      .modal("hide");
    window.$("#shareuser" + this.state.forumData.id).modal("hide");
  }

  redirect(id) {
    window.location = "/forumDetail/" + id;
  }

  forumPinned = () => {
    let body = {
      userId: this.state.userId,
      activityId: this.state.forumData.id,
      pinned: !this.state.forumData.pinned,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/backend/pinned/create",
      headers: { "Content-Type": "application/json" },
      data: body,
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.message === "Success!") {
          this.getForumDetails();
        }
      })
      .catch((err) => {
        this.setState({
          isLoaded: true,
          error: { message: err.response.data.message, err: err.response },
        });
      });
  };

  redirectToProfile = (customUrl) => {
    this.setState({ redirectToProfile: customUrl });
  };

  renderTaggedUsers = (text) => {
    if (!text || text.length === 0) {
      return text;
    }
    text = text.replace(/data-value=\&quot;#/gi, "data-value=&quot;");

    text = text.split("@@@__").join('<a href="/profile/');
    text = text.split("^^__").join('">');
    text = text.split("&&__").join('">');
    text = text.split("&amp;&amp;__").join('">');
    text = text.split("&amp;&amp;__").join('">');
    text = text.split("@@@^^^").join("</a>");
    text = text
      .split("###__")
      .join(
        '<a class="hashLinkPost" style="cursor:pointer" href="/explore-hashtag/'
      );
    text = text
      .split("&&__")
      .join(
        '<a class="hashLinkPost" style="cursor:pointer" href="/explore-hashtag/'
      );
    text = text.split("###^^^").join("</a>");
    text = text.replace(/#\s/g, "");
    //text = text.replace(/[\"#]+/g, '');
    //text = text.replace(/>/g, '');
    //text = text.replace("&lt;p&gt;", "");
    //text = text.replace("&lt;/p&gt;", "");

    return text;
  };

  getForumDetails = () => {
    let url;
    if (this.state.loginSuccess) {
      url = `/forum/get?slug=${this.props.match.params.slug}&userId=${this.state.userId}&admin=false${userAgentGetData()}`;
    } else {
      url = `/unauth/forum/get/slug?slug=${this.props.match.params.slug}&admin=${adminFlagData() ? true : false}`;
    }
    axios({
      method: "get",
      url: process.env.REACT_APP_userServiceURL + url,
      headers: { "Content-Type": "application/json" },

      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "200 OK") {
          this.setState({ forumData: res.body, forumResponseMessage: res.message, adminFlag: !this.state.loginSuccess ? (adminFlagData() ? true : false) : false }, () => {
            document.title = res.body.title;
            if (this.state.loginSuccess) {
              this.setState(
                {
                  page: 0,
                },
                () => {
                  this.getAllComments(this.state.page, 5, false);
                }
              );
            }
            // this.handlePageClickHookPost();
          });
        }
      })
      .catch((err) => {
        if (err.response && (err.response.status === 404 || err.response.status === 410)) {
          this.setState({
            notFoundstatusCode: true,
          });
        }
        this.setState({
          isLoaded: true,
          error: { message: err.response.data.message, err: err.response },
        });
      });
  };

  fetchMoreCommentData = () => {
    this.setState({ isResultLoading: true, page: this.state.page + 1 }, () => {
      this.getAllComments(this.state.page, 5, true);
    });
  };
  getAllComments = (page, size, concatWithPrevious) => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/comment/getCommentsByActivityId/" +
        this.state.forumData.id +
        "?userId=" +
        this.state.userId +
        "&page=" +
        page +
        "&size=" +
        size,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.message === "Success!") {
          let pagedData = response.data.body;
          if (concatWithPrevious) {
            if (
              this.state.comments.content &&
              this.state.comments.content.length > 0
            ) {
              let comments = cloneDeep(this.state.comments.content);
              pagedData.content = comments.concat(pagedData.content);
            }
          }
          this.setState({
            comments: pagedData,
            commentCount:
              response.data.body.content.length > 0
                ? response.data.body.content[0].commentsCount
                : 0,
            pagination: response.data.body.last,
            successMessage: "Success!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  openDeleteModal = (id) => {
    window
      .$("#confirmpopForDeleteForum" + this.state.forumData.id)
      .modal("show");
  };

  deleteForum = (id) => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/backend/public/forum/delete?forumId=" +
        id,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "202 ACCEPTED") {
          //window.location.href = "/forum/";
          this.props.history.goBack();
        }
      })
      .catch((err) => {
        this.setState({
          isLoaded: true,
          error: { message: err.response.data.message, err: err.response },
        });
      });
  };
  triggerReportClose = () => {
    this.setState({ openReportModal: null });
  };

  handleLoginClose = () => {
    this.setState({ loginRequired: false });
    window.$("#loginModal").modal("hide");
  };

  handleUnHideModal = (id) => {
    let data = {
      userId: this.state.userId,
      activityId: id,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/hidden/unhide",
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.status === 202) {
          this.getForumDetails();
        } else {
          this.setState({ isSubmitted: false });
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 409) {
          this.setState({
            error: "Entity has already been unhidden",
            isSubmitted: false,
          });
        } else {
          this.setState({ isSubmitted: false });
        }
      });
  };

  handleHideModal = (id) => {
    let data = {
      userId: this.state.userId,
      activityId: id,
      entityType: "FORUM",
    };

    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/hidden/hide",
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.status === 201) {
          //window.location.href = "/forum";
          this.props.history.goBack();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 409) {
          //  this.setState({'error': 'Entity has already been hidden', 'isSubmitted': false});
          console.log();
        } else {
          //  this.setState({'isSubmitted': false});
          console.log();
        }
      });
  };

  refreshAllData = () => {
    window.location.href = "/forum";
  };

  refresh_comment = () => {
    this.setState(
      {
        pageNo: 0,
        pageSize: 5,
      },
      () => {
        this.getAllComments(this.state.page, 5, false);
      }
    );
  };

  showStatsFunction = () => {
    this.setState({showStatsFlag: true},() =>{
      window.$('.forumdescmain .postVStats').click(function (event) {
        window.$(".potViewGlobal").collapse('toggle');
      });
    })
  }

  getForumDetailsSection = (date, linkfiedHtml) => {
    return(<>
          <div className="forumdesctop">
            <div className="forumdesctophead">
              <div className="fdtheadleft">
                <div className= {"fuserfollow" + (this.state.forumData.userType === "COMPANY" ? " orgnzName" : "")}>
                  <figure
                    className="userlogo"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      this.redirectToProfile(
                        this.state.forumData.customUrl
                      );
                    }}
                  >
                    <img
                      src={
                        this.state.forumData.profileImage !=
                        null
                          ? getCDNUrl(
                              this.getOptimizedImage(
                                this.state.forumData
                              )
                            )
                          : this.state.forumData.userType !==
                            "COMPANY"
                          ? "https://cdn.dscovr.com/images/users1.png"
                          : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                      }
                      alt=""
                    />
                  </figure>
                  <a
                    href="javascript:void(0)"
                    onClick={(e) => {
                      e.preventDefault();
                      this.redirectToProfile(
                        this.state.forumData.customUrl
                      );
                    }}
                  >
                    {this.state.forumData.createdBy}
                  </a>
                  {this.state.forumData && this.state.loginSuccess && (
                    <Follow
                      followed={this.state.forumData.followed}
                      userId={this.state.forumData.userId}
                      deactivated={
                        this.state.forumData.deactivated
                      }
                    />
                  )}
                </div>
                <h1>{this.state.forumData.title}</h1>
              </div>
              <div className="fdtheadright">
                <span>Published on {date}</span>
                {this.state.loginSuccess && <Pinned item={this.state.forumData} entityType={"FORUM"} />}
              </div>
            </div>
          </div>

          {this.state.userId && <OrganizationAdmin userId={this.state.userId} isNotTopSpace={true} />}

          <div className="forumdescmain">
            <div className="toptitleblk">
                <h5>
                    BASIC DESCRIPTION{" "}
                    {this.state.forumData &&
                    !this.state.forumData.selfHidden && (
                        <Link to="/forum" className="viewsource">
                        <i className="iArrow-Up" />
                        View Source
                        </Link>
                    )}
                </h5>                                
              
                {this.state.loginSuccess && <div className="contxmenu">
                    <button
                    type="button"
                    className="btn"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >
                    <i className="iKebab" />
                    </button>
                    <div className="dropdown-menu fadeIn animated">
                    {this.state.forumData.userId ===
                        this.state.userId && (
                        <span
                        className="dropdown-item"
                        onClick={(e) => {
                            this.openDeleteModal(
                            this.state.forumData.id
                            );
                        }}
                        >
                        <i className="iTrashBin" /> Delete
                        </span>
                    )}
                    {(this.state.forumData && this.state.forumData.hidden === true ? (
                        <span
                        className="dropdown-item"
                        onClick={(e) => {
                            this.handleUnHideModal(
                            this.state.forumData.id
                            );
                        }}
                        >
                        <i
                            className="iEye_F"
                            style={{ fontSize: "13px" }}
                        />{" "}
                        Unhide
                        </span>
                    ) : (
                        !this.state.forumData.selfHidden && !this.state.forumData.pinned && (
                        <span
                            className="dropdown-item"
                            onClick={(e) => {
                            this.handleHideModal(
                                this.state.forumData.id
                            );
                            }}
                        >
                            {" "}
                            <i
                            className="iHide"
                            style={{ fontSize: "13px" }}
                            />{" "}
                            Hide
                        </span>
                        )
                    ))}
                    {this.state.forumData.userId !=
                        this.state.userId && (
                        <a
                        className="dropdown-item"
                        href="javascript:void(0)"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                            openReportModal:
                                this.state.forumData.id,
                            });
                        }}
                        >
                        <i className="iReportComment_OL" /> Report
                        </a>
                    )}
                    </div>

                    {this.state.openReportModal &&
                    this.state.openReportModal ===
                        this.state.forumData.id && (
                        <ReportAbuse
                        entityId={this.state.forumData.id}
                        entityType={"FORUM"}
                        refreshAllData={this.refreshAllData}
                        triggerReportClose={
                            this.triggerReportClose
                        }
                        />
                    )}
                </div>}
              
            </div>

            {/* <p
              dangerouslySetInnerHTML={{
                __html: linkfiedHtml,
              }}
            /> */}
            <div className="forumdescTxt">
                <div
                dangerouslySetInnerHTML={{
                    __html: linkfiedHtml,
                }}
                />
            </div>

            {this.state.forumData.hashTags && (
              <div className="frdtagslist">
                {this.state.forumData.hashTags.map((item) => {
                  return (
                    <span key={item}>
                      <a href={"/explore-hashtag/" + item}>
                        {item}
                      </a>
                    </span>
                  );
                })}
              </div>
            )}

            {/* impression Stats  section for forum*/}
            
              <>
                <div className={"hpostcontbott " + (this.state.loginSuccess && this.state.forumData?.userId === this.state.userData.userId && this.state.showStatsFlag && "pr-5")}>
                    {this.state.loginSuccess ? (this.state.forumData &&
                      !_.isUndefined(
                        this.state.forumData.likesCount
                      ) && <>
                          <UserReactionComponent item={this.state.forumData} key={this.state.forumData.id} />
                          <a className="comments" id="commntIco">
                            <span className="art_btn_bx">
                              {this.state.commentCount}{" "}
                              {this.state.commentCount &&
                              this.state.commentCount > 1 ? (
                                <span>Comments</span>
                              ) : (
                                <span>Comment</span>
                              )}
                            </span>
                          </a>
                        </>
                      ) : (
                        <><div className="likesblk">
                          <a href="javascript:void(0)" onClick={this.handleLike.bind(this)} className={"like" }/>
                          <a href="javascript:void(0)" onClick={this.handleLike.bind(this)}>
                              {this.state.forumData &&
                                this.state.forumData.likesCount}
                              &nbsp;
                              <span>
                                {this.state.forumData &&
                                this.state.forumData.likesCount <= 1 ?"Like" :"Likes" }
                              </span>
                          </a>
                        </div>
                        <a href="javascript:void(0)" onClick={this.handleLike.bind(this)} className="comments" id="commntIco">
                          <span className="art_btn_bx">
                              {this.state.forumData.commentCount}&nbsp;
                                <span>
                                {this.state.forumData.commentCount <= 1 ?"Comment" :"Comments" }
                            </span>
                          </span>
                        </a>
                        </>
                      )}
                    {this.state.loginSuccess ? (window.location.href.indexOf(
                      "share-open"
                    ) !== -1
                      ? this.state.forumData &&
                        this.state.forumData.id && (
                          <Share
                            shareUrl="/forumDetail/"
                            entityId={this.state.forumData.id}
                            entityType={"FORUM"}
                            slug={this.props.match.params.slug}
                            shareId={this.state.forumData.id}
                            shareOpen="true"
                            sharesCount={
                              this.state.forumData.sharesCount
                            }
                          />
                        )
                      : this.state.forumData &&
                        this.state.forumData.id && (
                          <Share
                            shareUrl="/forumDetail/"
                            entityId={this.state.forumData.id}
                            entityType={"FORUM"}
                            slug={this.props.match.params.slug}
                            shareId={this.state.forumData.id}
                            sharesCount={
                              this.state.forumData.sharesCount
                            }
                          />
                        )) : (window.location.href.indexOf("share-open") !== -1 ? this.state.forumData &&
                            this.state.forumData.id && (
                              <UnauthShare shareUrl="/forumDetail/" entityId={this.state.forumData.id} entityType={"FORUM" } shareId={this.props.match.params.slug} shareOpen="true"/>
                            )
                          : this.state.forumData &&
                            this.state.forumData.id && (
                              <UnauthShare shareUrl="/forumDetail/" entityId={this.state.forumData.id} entityType={"FORUM" } shareId={this.props.match.params.slug}/>
                            ))}
                    {this.state.loginSuccess && this.state.forumData && this.state.forumData?.userId === this.state.userData.userId && this.state.showStatsFlag &&
                      <a href="javascript:void(0)" className="postVStats" data-toggle="collapse" />
                    }
                </div>
                {this.state.loginSuccess && this.state.forumData && this.state.forumData?.userId === this.state.userData.userId &&
                  <div className="fadeIn animated potViewGlobal collapse">
                    <CommonPostViews entityId={this.state.forumData?.id } details={true} shareCount={this.state.forumData?.sharesCount} interactionsCount={this.state.forumData?.commentCount+this.state.forumData?.likesCount+this.state.forumData?.sharesCount} entityType={"FORUM"} showStatsFunction={this.showStatsFunction} />
                  </div>
                }
            </>
    
            
          </div>
         

          {this.state.loginSuccess && <div className="forumdescbott">
            <div className="row">
              <div className="col-lg-12">
                <div style={{ position: "relative" }}>
                  <AddCommentBox item={this.state.forumData} getAllComments={this.getAllComments} pageType={"FORUM_DETAILS"} />
                  {this.state.comments &&
                    this.state.comments.content &&
                    this.state.comments.content.length > 0 && (
                      <div className="forumcommtvlistwrap">
                        {this.state.comments &&
                          this.state.comments.content &&
                          this.state.comments.content.map(
                            (comment) => {
                              return (
                                <Comment
                                  item={comment}
                                  key={comment.id}
                                  callback={this.getAllComments}
                                  refresh={this.refresh_comment}
                                />
                              );
                            }
                          )}
                      </div>
                    )}
                  {this.state.successMessage === "Success!" &&
                    !this.state.pagination && (
                      <div
                        className="text-center"
                        style={{ padding: "15px 0" }}
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) =>
                            this.fetchMoreCommentData()
                          }
                          className="btn cLoadmore"
                        >
                          LoadMore
                        </a>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>}
        </>
    )
  }

  render() {
   
    var dateFormat = require("dateformat");
    if (!_.isUndefined(this.state.forumData.createTime)) {
      if (
        dateFormat(new Date(this.state.forumData.createTime), "yyyy") ===
        new Date().getFullYear().toString()
      ) {
        var date = dateFormat(
          new Date(this.state.forumData.createTime),
          "dd-mmm"
        );
      } else {
        var date = dateFormat(
          new Date(this.state.forumData.createTime),
          "dd-mmm-yyyy"
        );
      }
    }
    const utcSeconds = this.state.forumData && this.state.forumData.createTime;
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds / 1000);
    let linkfiedHtml =
      '<p class="pdtlsLink forum-pdtlsLink">' +
      this.renderTaggedUsers(
        this.state.forumData.comment ? this.state.forumData.comment : ""
      ) +
      "</p>";
    if (!this.state.loginSuccess) {
      return (
        <div
          className={"wrapper projectpage forumpage nologinpage" + (((this.state.notFoundstatusCode || this.state.forumData.deleted || this.state.forumData.hidden) && !this.state.adminFlag) && !this.state.adminFlag ? " p404 staticPage" : "")}
        >
          {this.state.redirectToProfile && (
            <Redirect push to={"/profile/" + this.state.redirectToProfile} />
          )}
          <BypassHeader
            notFound={
              (this.state.notFoundstatusCode ||
              this.state.forumData.hidden)
                ? true
                : false
            }
            display={this.state.notFoundstatusCode ? true : false}
          />
          <main className="dgcontainer hm3col">
            <div className="container">
              {((this.state.notFoundstatusCode || this.state.forumData.deleted) && !this.state.adminFlag) ? (
                <HideInfoPage deletePost={true} />
              ) : this.state.forumResponseMessage === "Success!" && this.state.forumData.hidden && !this.state.adminFlag ? <PrivateProjectHidePage myStudioPage={true} /> : (
                <div className="row">
                  <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                  <div className="col-md-9">
                    <div className="projectinn">
                      {this.getForumDetailsSection(date, linkfiedHtml)}

                      <UnauthPageItem signUpRequired={this.signUpRequired} pathName={`forumDetail/${this.props.match.params.slug}`} history={this.props.history} />

                      <div className="bottomFloatButton">
                        <a
                          href="javascript:void(0)"
                          onClick={this.signUpRequired.bind(this)}
                          className="bkloginBtn"
                        >
                          <span>Join Us</span> to discover your passion for
                          nature
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </main>

          {((this.state.notFoundstatusCode || this.state.forumData.deleted || this.state.forumData.hidden) && !this.state.adminFlag) && 
            <LeftPanelUnauth signUpRequired={this.signUpRequired} />
          }
          
          {this.state.loginRequired === true ? (
            <AuthModalComponent
              pathname={this.state.pathname}
              history={this.props.history}
              handleLoginClose={this.handleLoginClose}
            />
          ) : null}
          {this.state.signUpRequired === true ? (
            <SignUpModal
              handleSignUpClose={this.handleSignUpClose}
              history={this.props.history}
            />
          ) : null}
        </div>
      );
    } else {
      return (
        <>
          {this.state.redirectToProfile && (
            <Redirect push to={"/profile/" + this.state.redirectToProfile} />
          )}
          <div className={"wrapper projectpage forumpage allDetailsPage" + (((this.state.notFoundstatusCode || this.state.forumData.deleted || (this.state.forumResponseMessage === "Success!" && this.state.forumData.hidden)) && (this.state.forumData.userId !== this.state.userId)) ? " staticPage" : "")}>
            <Header EditedText={true} />
            <main className="dgcontainer hm3col">
              <div className="container">
                {(this.state.notFoundstatusCode || this.state.forumData.deleted) && (this.state.forumData.userId !== this.state.userId) ? (
                  <HideInfoPage deletePost={true} />
                ) : this.state.loginSuccess && this.state.forumResponseMessage === "Success!" && this.state.forumData.hidden && this.state.forumData.userId !== this.state.userId /* !this.state.forumData.myHidden */ ? <PrivateProjectHidePage myStudioPage={true}/> : (
                  <div className="row">
                    <LeftPanel />
                    <div className="col-md-9">                      
                      <div className="projectinn">                       

                        {this.getForumDetailsSection(date, linkfiedHtml)}

                        <div className="modal fade dgpopup confirmpop" id={ "confirmpopForDeleteForum" + this.state.forumData.id } tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                          <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                                            {/* <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Delete Confirmation</h5>
                              </div> */}
                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                              <div className="confirm-popup-modal-body">
                                                              Are you sure you want to delete this
                                                              forum?
                                                            </div>
                              <div className="modal-footer confirm-popup-modal-footer">
                                <button type="button" className="btn btn-primary" onClick={()=>this.deleteForum(this.state.forumData.id)
                                      }
                                    >
                                      Yes
                                </button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                      No
                                </button>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </main>
            {(this.state.notFoundstatusCode || this.state.forumData.deleted || (this.state.forumResponseMessage === "Success!" && this.state.forumData.hidden)) && (this.state.forumData.userId !== this.state.userId) && <LeftPanel /> }
          </div>
        </>
      );
    }
  }
}

export default withRouter(ForumDetail);
